import { AlertType } from '@/shared/types/Alert';

import { getErrorMessage } from './getErrorMessage';
import { enqueueAppSnackbar } from './snackbar';

export const showErrorAlert = (error: unknown) => {
  enqueueAppSnackbar(getErrorMessage(error), { variant: AlertType.Error });
};
